import type { FeatureLike } from "ol/Feature";
import type { MapBrowserEvent } from "ol";
import type { Coordinate } from "ol/coordinate";
import type Geometry from "ol/geom/Geometry";
import RenderFeature, { toFeature } from "ol/render/Feature";
import { MapClick } from "../../../../../reactOL/interactions";
import useGetOrderItemInrixVolumeParams from "../controls/GetOrderItemInrixVolumeParams";
import { parseInrixVolumeFeature } from "../models/InrixVolumeFeature";
import { getInrixVolumeFeatureValue } from "../utils/getInrixVolumeFeatureValue";
import { useFeatureContext } from "../../../../../../context/Feature";
import Feature from "ol/Feature";
import type { InrixVolumesViewOrderItemSummary } from "../../../../../../types/ViewOrderItem/InrixVolumes/InrixVolumesViewOrderItemSummary";

interface OrderItemInrixVolumeMapClickProps {
  active: boolean;
  summary: InrixVolumesViewOrderItemSummary | null;
}

const convertToFeature = (featureLike: FeatureLike): Feature | null => {
  if (featureLike instanceof Feature) {
    return featureLike;
  }

  if (featureLike instanceof RenderFeature) {
    return toFeature(featureLike);
  }

  return null;
};

const OrderItemInrixVolumeMapClick = ({
  active,
  summary,
}: OrderItemInrixVolumeMapClickProps) => {
  const { timePeriod, timeIndex } = useGetOrderItemInrixVolumeParams();
  const { addFeature, clearFeatures } = useFeatureContext();

  const onClick = (features: FeatureLike[], e: MapBrowserEvent<any>) => {
    const feature = features.find((candidate) => {
      const model = parseInrixVolumeFeature(candidate);
      return (
        model !== null &&
        getInrixVolumeFeatureValue(model, timePeriod, timeIndex) !== null
      );
    });
    if (!feature) {
      clearFeatures();
      return;
    }

    const olFeature = convertToFeature(feature);
    if (olFeature) {
      if (summary) {
        olFeature.set("adtMin", summary.adtMin);
        olFeature.set("adtMax", summary.adtMax);
        olFeature.set("volMin", summary.volMin);
        olFeature.set("volMax", summary.volMax);
      }
      clearFeatures();
      addFeature(olFeature);
    }
  };

  return <MapClick active={active} onClick={onClick} hitTolerance={5} />;
};

export default OrderItemInrixVolumeMapClick;
